import {
  Interpolation,
  SerializedStyles,
  Theme,
  useTheme,
} from "@emotion/react";
import originalStyled, { CreateStyled } from "@emotion/styled";

const styled = originalStyled as CreateStyled;
export default styled;
// kvuli zachovani zpetne kompatibility u souboru kde nejsou absolutni importy
export { useTheme };
export type ThemedCssCreator = (theme: Theme) => SerializedStyles;

// Rozšíření InterpolationWithTheme o případy, kdy mám ArrayInterpolation
// ve kterém mám ThemedCssCreator prvky -  (normálně emotion nedovoluje
// v arrayi poslat ThemedCssCreator - viz `src/utils/emotion/composeCss`
export type ThemedInterpolation = Interpolation<Theme> | Interpolation<Theme>[];
